"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUBMIT_KEYS = void 0;
var SUBMIT_KEYS = new Set(['Enter', ' ']);
exports.SUBMIT_KEYS = SUBMIT_KEYS;